// Плавная прокрутка содержимого элемента до указанной позиции.

import * as Ease from './Ease';

/**
 * Элементы, прокрутка которых осуществляется в данный момент
 */
const currentlyScroll = new WeakSet();

/**
 * Плавная прокрутка содержимого элемента до указанной позиции.
 * 
 * @param element Элемент.
 * @param to Позиция прокрутки, в пикселах.
 * @param duration Длительность анимации, мс.
 * @param horizontal Горизонтальная прокрутка?
 * @param ease Функция изменения от времени.
 */
function scrollElementTo( element: HTMLElement | Window, to: number,
	duration: number, horizontal: boolean = false,
	ease: Ease.EasingFunction = Ease.quadInOut ): Promise<void>
{
	return new Promise<void>(
		( resolve: () => void ): void =>
		{
			if (
				( duration <= 0 )
				|| !element
			)
			{
				throw new Error( 'scrollElementTo: incorrect arguments.' );
			}
			
			if ( currentlyScroll.has( element ) )
			{
				resolve();
				
				return;
			}
			
			currentlyScroll.add( element );
			
			let startScroll: number;
			let setScroll: ( position: number ) => void;
			
			if ( element instanceof Window )
			{
				if ( horizontal )
				{
					startScroll = element.pageXOffset;
					setScroll = ( position: number ) =>
						element.scrollTo( position, element.pageYOffset );
				}
				else
				{
					startScroll = element.pageYOffset;
					setScroll = ( position: number ) =>
						element.scrollTo( element.pageXOffset, position );
				}
			}
			else if ( element instanceof HTMLElement )
			{
				if ( horizontal )
				{
					startScroll = element.scrollLeft;
					setScroll = ( position: number ) =>
						element.scrollLeft = position;
				}
				else
				{
					startScroll = element.scrollTop;
					setScroll = ( position: number ) =>
						element.scrollTop = position;
				}
			}
			else
			{
				resolve();
				
				return;
			}
			
			const distance = to - startScroll;
			const startTime = Date.now();
			
			const tick = (): void =>
			{
				const time = (Date.now() - startTime) / duration;
				
				if ( time >= 1 )
				{
					setScroll( to );
					currentlyScroll.delete( element );
					resolve();
					
					return;
				}
				
				setScroll( startScroll + distance * ease( time ) | 0 );
				window.requestAnimationFrame( tick );
			};
			
			tick();
		},
	);
}

/**
 * Module
 */
export {
	scrollElementTo as default,
};



// WEBPACK FOOTER //
// ./utils/animation/scrollElementTo.ts